import { render, staticRenderFns } from "./TrashList.vue?vue&type=template&id=54c67934&scoped=true"
import script from "./TrashList.vue?vue&type=script&lang=js"
export * from "./TrashList.vue?vue&type=script&lang=js"
import style0 from "./TrashList.vue?vue&type=style&index=0&id=54c67934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c67934",
  null
  
)

export default component.exports